var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_758702",
    clipPath: "url(#clip0_7964_1720)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2763 41.0806C28.8944 39.5731 26.5076 39.4474 24.9999 40.8293C23.4925 42.2112 23.3667 44.598 24.7486 46.1057L43.7185 66.7088C44.4724 67.4627 45.3517 67.965 46.3566 67.965C46.3566 67.965 46.3566 67.965 46.4821 67.965C47.4873 67.965 48.4922 67.5882 49.1202 66.8343L97.1106 18.97C98.618 17.4625 98.618 15.0755 97.1106 13.6936C95.6031 12.1861 93.2161 12.1861 91.8342 13.6936L46.6081 58.7941L30.2763 41.0806Z",
    fill: "#1FAF38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M96.2313 46.2311C94.0955 46.2311 92.4625 47.8644 92.4625 49.9999C92.4625 73.3666 73.3671 92.4623 50.0001 92.4623C26.6331 92.4623 7.53771 73.3669 7.53771 50.0001C7.53771 26.6334 26.6331 7.53771 50.0001 7.53771C52.1359 7.53771 53.7689 5.9045 53.7689 3.76898C53.7689 1.63345 52.1357 0 50.0001 0C22.4874 0 0 22.4874 0 50.0001C0 77.5129 22.4874 100 50.0001 100C77.5129 100 100 77.5129 100 50.0001C100 47.8644 98.367 46.2311 96.2313 46.2311Z",
    fill: "#1FAF38"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7964_1720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.bb27858cad2514271986d27c9b2059df.svg";
export { ForwardRef as ReactComponent };